import {ActionTree} from "vuex";
import {
  TarificationState,
  TariffZoneGroupItem,
  TariffZoneItem,
  TarificationTransports,
  TarificationTypes,
  TariffFilterParams,
  TariffItem
} from "@/store/tarification/types";
import {RootState} from "@/store/types";
import axios, { AxiosResponse } from "axios";

export const actions: ActionTree<TarificationState, RootState> = {
  getTariffZones: ({commit, dispatch}, data: any) => {
    let url = '';
    if (data.partner_id) {
      url = `/acapi/${data.transport.toLowerCase()}/partners/${data.partner_id}/tariff_zones`
    } else if (data.operator_id) {
      url = `/acapi/${data.transport.toLowerCase()}/service_providers/${data.operator_id}/tariff_zones`
    } else {
      commit('setTariffZones', []);
      return Promise.resolve()
    }
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        url: url,
        params: data.filter,
      })
        .then((resp:any) => {
          commit('setTariffZones', resp.data.tariff_zones);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getTariffZoneItem: ({commit, dispatch}, data: any) => {
    let url = '';
    if (data.partner_id) {
      url = `/acapi/${data.transport}/partners/${data.partner_id}/tariff_zones/${data.id}`
    } else if (data.operator_id) {
      url = `/acapi/${data.transport}/service_providers/${data.operator_id}/tariff_zones/${data.id}`
    }
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        url: url,
      })
        .then((resp:any) => {
          let tariffZoneItem = <TariffZoneItem>resp.data;
          tariffZoneItem.id = data.id;
          commit('setTariffZoneItem', tariffZoneItem);
          resolve(tariffZoneItem)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getTariffZoneGroupItem: ({commit, dispatch}, data: any) => {
    let url = '';
    if (data.partner_id) {
      url = `/acapi/${data.transport}/partners/${data.partner_id}/tariff_zone_groups`
    } else if (data.operator_id) {
      url = `/acapi/${data.transport}/service_providers/${data.operator_id}/tariff_zone_groups`
    } else {
      commit('setTariffZoneGroupItem', []);
      return Promise.resolve()
    }
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        url: url,
      })
        .then((resp:any) => {
          let tariffZoneGroupItem = <TariffZoneGroupItem>resp.data;
          commit('setTariffZoneGroupItem', tariffZoneGroupItem);
          resolve(tariffZoneGroupItem)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  saveTariffZoneItem: ({commit, dispatch}, data:any) => {
    let url = '';
    if (data.partner_id) {
      url = `/acapi/${data.transport}/partners/${data.partner_id}/tariff_zones/${(data.item.id ?? '')}`
    } else if (data.operator_id) {
      url = `/acapi/${data.transport}/service_providers/${data.operator_id}/tariff_zones/${(data.item.id ?? '')}`
    }
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.item.id ? 'put' : 'post',
        url: url,
        data: data.item
      })
        .then((resp:any) => {
          dispatch('getTariffZones', data);
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  saveTariffZoneGroupItem: ({commit, dispatch}, data:any) => {
    let url = '';
    if (data.partner_id) {
      url = `/acapi/${data.transport}/partners/${data.partner_id}/tariff_zone_groups`
    } else if (data.operator_id) {
      url = `/acapi/${data.transport}/service_providers/${data.operator_id}/tariff_zone_groups`
    }
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: url,
        data: data.item
      })
        .then((resp:any) => {
          dispatch('getTariffZones', data);
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deleteTariffZoneItem: ({commit, dispatch}, data: any) => {
    let url = '';
    if (data.partner_id) {
      url = `/acapi/${data.transport}/partners/${data.partner_id}/tariff_zones/${data.item.id}`
    } else if (data.operator_id) {
      url = `/acapi/${data.transport}/service_providers/${data.operator_id}/tariff_zones/${data.item.id}`
    }
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: url,
        data: data
      })
        .then((resp:any) => {
          dispatch('getTariffZones', data);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  importTariffZones: ({commit, dispatch}, data:any) => {
    let url = '';
    if (data.partner_id) {
      url = `/acapi/${data.transport.toLowerCase()}/partners/${data.partner_id}/tariff_zones/import`
    } else if (data.operator_id) {
      url = `/acapi/${data.transport.toLowerCase().replace(' ','_')}/service_providers/${data.operator_id}/tariff_zones/import`
    }
    commit('setLoading', true);
    return new Promise(async (resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        data: data.item
      })
        .then((resp:any) => {
          dispatch('getTariffZones', data);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  async getTariffs({commit}, data: {transport: TarificationTransports, tariffType: TarificationTypes, filter: TariffFilterParams}) {
    const url = `/acapi/${data.transport.toLowerCase().replace(' ','_')}/${data.tariffType.toLowerCase()}/tariffs`;
    commit('setLoading', true);
    try {
      const resp: AxiosResponse<{tariffs: TariffItem[]}> = await axios({url: url, params: data.filter})
      commit('setTariffs', resp.data.tariffs);
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false)
    }
  },
  async getTariffItem({commit}, data: {transport: TarificationTransports, tariffType: TarificationTypes, tariff_id: number}) {
    const url = `/acapi/${data.transport.toLowerCase().replace(' ','_')}/${data.tariffType.toLowerCase()}/tariffs/${data.tariff_id}`;
    commit('setLoading', true);
    try {
      const resp: AxiosResponse<TariffItem> = await axios({url: url})
      const tariffItem: TariffItem = resp.data;
      tariffItem.id = data.tariff_id;
      commit('setTariff', tariffItem);
      return tariffItem;
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false)
    }
  },
  async saveTariffItem(
    {commit,dispatch},
    data: {transport: TarificationTransports, tariffType: TarificationTypes, item: TariffItem}
  ) {
    const url = `/acapi/${data.transport.toLowerCase().replace(' ','_')}/${data.tariffType.toLowerCase()}/tariffs/${(data.item.id ?? '')}`;
    commit('setLoading', true);
    try {
      const resp: AxiosResponse<any> = await axios({
        method: data.item.id ? 'put' : 'post',
        url: url,
        data: data.item
      })
      dispatch('getTariffs', data);
      return resp
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false)
    }
  },
  async deleteTariffItem(
    {commit,dispatch},
    data: {transport: TarificationTransports, tariffType: TarificationTypes, item: TariffItem}
  ) {
    // TODO replace тоже надо будет убрать после приведение mail notify в единый формат
    const url = `/acapi/${data.transport.toLowerCase().replace(' ','_')}/${data.tariffType.toLowerCase()}/tariffs/${data.item.id}`;
    commit('setLoading', true);
    try {
      const resp: AxiosResponse<any> = await axios({
        method: 'delete',
        url: url,
        data: data.item
      })
      dispatch('getTariffs', data);
      return resp
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false)
    }
  },
  importTariffs: ({commit, dispatch}, data:any) => {
    let url = '';
    if (data.type === TarificationTypes.PARTNER) {
      url = `/acapi/${data.transport.toLowerCase().replace(' ','_')}/partners/tariffs/import`
    } else {
      url = `/acapi/${data.transport.toLowerCase().replace(' ','_')}/service_providers/tariffs/import`
    }
    commit('setLoading', true);
    return new Promise(async (resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        data: data.item
      })
          .then((resp:any) => {
            dispatch('getTariffs', data);
            resolve(resp)
          })
          .catch((err:any) => {
            reject(err)
          })
          .finally(() => commit('setLoading', false))
    })
  },
}
